// TruncatedText.js
import React from 'react';

const TruncatedText = ({ text, style }) => {
  // Check if the text length exceeds 25 characters
  const truncatedText = text.length > 150 ? text.substring(0, 150) + '...' : text;

  return <span style={style}>{truncatedText}</span>;
};

export default TruncatedText;
